<template>
  <div id='myContainer'></div>
</template>

<script>
  //  import { Loading } from 'element-ui';
  //  import Z from './assets/ZoomifyImageViewerPro-src'

  export default {
    name: 'canvas-gsh',
    props: ['md5'],
    data () {
      return {}
    },
    mounted () {
      /* global Z */
      Z.showImage('myContainer', 'http://zif.gushuhua.org/' + this.$route.params.md5 + '.zif',
        'zInitialFullPage=1&zFullPageVisible=1&zNavigatorVisible=0&zToolbarVisible=0')
    }
  }
</script>

<style>
  .myContainer {
    width: 100%
  }
</style>



// WEBPACK FOOTER //
// Canvas.vue?d750064a